module.exports = __webpack_public_path__ + "img/1716356419378-WhatsApp Image 2024-05-22 at 10.35.31.jpeg.d83bf735.webp";